<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="samplePropertiesImageCode"
      border
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
      :checkbox-config="{ highlight: true, trigger: 'row' }"
      :cell-class-name="cellClassName"
    >
      <template v-slot:displayImage="{ row }">
        <el-image
          :src="
            row.imageUrl ? $osscdn(row.imageUrl) : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:100px"
          fit="contain"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 100px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:samplePropertiesType="{ row }">
        <el-tag
          size="mini"
          :type="
            row.samplePropertiesType === 'A'
              ? 'success'
              : row.samplePropertiesType === 'B'
              ? 'primary'
              : 'danger'
          "
        >
          {{ row.v_samplePropertiesType }}
        </el-tag>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns.js'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  methods: {
    cellClassName({ column }) {
      return column.property
    },
    getCheckboxRecords() {
      return this.$refs.table.getCheckboxRecords(true)
    },
    setCheckboxRecords(keys) {
      const $table = this.$refs.table
      $table.setAllCheckboxRow(false)
      if (!keys || !keys.length) return
      const rows = keys.map((key) => $table.getRowById(key)).filter(Boolean)
      if (!rows || !rows.length) return
      $table.setCheckboxRow(rows, true)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .displayImage {
    .vxe-cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
